import { Check } from "@icon-park/svg";
import { Icon } from "@justhome/react-ui";
import clsx from "clsx";
import { FC, PropsWithChildren } from "react";
interface ProcessStepProps {
  label: string;
  completed: boolean;
  selected: boolean;
  index: number;
  onPreviousStep: VoidFunction;
}

const ProcessStep: FC<ProcessStepProps> = ({
  completed,
  label,
  selected,
  index,
  onPreviousStep,
}) => {
  return (
    <li
      role="none"
      className={clsx("text-h4", {
        "text-neutral-425": !selected,
        "text-primary-800": selected,
        "opacity-60": !(completed || selected),
      })}
    >
      {index > 0 && (
        <div className={clsx("h-m w-3s flex justify-center")}>
          <div
            className={clsx("w-[2px]", {
              "bg-neutral-425": !(selected || completed),
              "bg-primary-800": selected || completed,
            })}
          ></div>
        </div>
      )}
      <button
        disabled={!completed}
        onClick={() => onPreviousStep()}
        className="flex gap-3xs items-center"
      >
        <div
          className={clsx(
            "flex-none text-neutral-0 border-[2px] rounded-full flex justify-center items-center h-3s w-3s",
            {
              "bg-primary-800": completed,
              "border-primary-800": completed || selected,
              "border-neutral-425": !(completed || selected),
            },
          )}
        >
          <Icon
            icon={Check}
            size="14"
            strokeWidth={8}
            className={clsx("transition-opacity", {
              "opacity-0": !completed,
              "opacity-100": completed,
            })}
          />
        </div>
        {label}
      </button>
    </li>
  );
};

interface ProcessStepsProps extends PropsWithChildren {}

const ProcessSteps: FC<ProcessStepsProps> = ({ children }) => {
  return <ul>{children}</ul>;
};

export default Object.assign(ProcessSteps, { Step: ProcessStep });
